import { memo, useCallback, useState } from 'react'
import { Box } from '@/components/Layout'
import { ImageSlider, ImageThumbnailSlider, SwiperClass } from '../Swiper'
import Modal, { ModalCloseReason } from '../Modal'
import { withErrorBoundary } from '@/components/Utils'
import { imageGalleryModalStyles as styles } from './ImageGalleryModal.style'
import { ImageGalleryModalProps } from './ImageGalleryModal.types'
import { useTranslations } from '@/core/translation'
import { SxProps } from '@mui/material'

function ImageGalleryModal({
  images,
  onClose,
  wrapperProps = {},
  galleryImageWrapperProps = {},
  imageSliderProps = {},
  imageThumbnailSliderProps = {},
  ...props
}: ImageGalleryModalProps) {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperClass | null>(null)
  const [activeSlide, setActiveSlide] = useState<number>(0)

  const t = useTranslations('components')

  const onCloseWrapper = useCallback(
    (event: object, reason: ModalCloseReason) => {
      setThumbsSwiper(null)
      onClose?.(event, reason)
      setActiveSlide(0)
    },
    [onClose],
  )

  // props extraction
  const { sx: wrapperSx, ...otherWrapperProps } = wrapperProps
  const { sx: galleryImageWrapperSx, ...otherGalleryImageWrapperPropsProps } =
    galleryImageWrapperProps

  return (
    <Modal
      title={t('imageGallery.title')}
      showTitleOnTop
      showCloseIcon
      onClose={onCloseWrapper}
      {...props}>
      <Box sx={[styles.wrapper, wrapperSx] as SxProps} {...otherWrapperProps}>
        <Box
          sx={[styles.galleryImages, galleryImageWrapperSx] as SxProps}
          {...otherGalleryImageWrapperPropsProps}>
          <ImageSlider
            images={images}
            thumbsSwiper={thumbsSwiper}
            onSlideChange={(swiper) => setActiveSlide(swiper.activeIndex)}
            {...imageSliderProps}
          />
        </Box>
        <ImageThumbnailSlider
          images={images}
          onSwiper={setThumbsSwiper}
          activeIndex={activeSlide}
          {...imageThumbnailSliderProps}
        />
      </Box>
    </Modal>
  )
}

export default memo(withErrorBoundary(ImageGalleryModal))
